'use client'

import { ConfirmationModal } from '@/components/ui/confirmation-modal'

interface IDeleteBrandConfirmationModalProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    brandName: string
    isDeleting: boolean
    onConfirm: () => void | Promise<unknown>
}

export function DeleteBrandConfirmationModal({
    open,
    onOpenChange,
    brandName,
    isDeleting,
    onConfirm,
}: IDeleteBrandConfirmationModalProps) {
    return (
        <ConfirmationModal
            open={open}
            onOpenChange={onOpenChange}
            title={`Delete "${brandName}"?`}
            subtitle="This action cannot be undone."
            content={`Permanently delete "${brandName}" and all of its associated data, including products.`}
            requireConfirmation
            confirmText="Delete"
            destructive
            confirmDisabled={isDeleting}
            onConfirm={onConfirm}
        />
    )
}
